<div class="dialog d-flex direction-column align-center"
  [ngClass]="{
    'dialog--modern': appearance === 'modern',
    'dialog--danger': appearance === 'modern' && isDestructive,
    'dialog--batch-preview': appearance === 'modern' && isBatchPreview
  }">
  <button class="dialog-close-btn"
          [ngClass]="{ 'dialog-close-btn--modern': appearance === 'modern' }"
          type="button"
          (click)="dialogRef.close()"
          aria-label="Fechar"
          title="Fechar">
    X
  </button>

  <div class="dialog-header" [ngClass]="{ 'dialog-header--modern': appearance === 'modern' }">
    <!-- <div *ngIf="appearance === 'modern'" class="dialog-eyebrow" [ngClass]="{ 'dialog-eyebrow--danger': isDestructive }">
      {{ eyebrowText }}
    </div> -->

    <h1 class="dialog-title" [ngClass]="{ 'dialog-title--modern': appearance === 'modern' }" mat-dialog-title>
      <span *ngIf="appearance !== 'modern'" [innerHTML]="safeTextInit"></span>

      <strong *ngIf="dialogType === DialogTypeEnum.Optional ||
                     dialogType === DialogTypeEnum.OptionalWithField"
              [innerHTML]="safeBoldTitle"></strong>

      <span *ngIf="appearance !== 'modern'" [innerHTML]="safeTitle"></span>

      <strong *ngIf="dialogType === DialogTypeEnum.Confirmation">
        {{ data.template.boldTitle }}
        {{ data.template.boldWord }}
      </strong>
    </h1>
  </div>

  <!-- Modern: corpo da mensagem separado do título -->
  <div *ngIf="appearance === 'modern' && safeTitle" class="dialog-message--modern" [innerHTML]="safeTitle"></div>

  <p *ngIf="appearance === 'modern' && showSupportingText" class="dialog-supporting-text">
    {{ supportingText }}
  </p>

  <textarea *ngIf="dialogType === DialogTypeEnum.OptionalWithField"
            cols="30"
            rows="10"
            class="dialog-field mt-50"
            [ngClass]="{ 'dialog-field--modern': appearance === 'modern' }"
            [placeholder]="data.template.description ?? ''"
            [attr.aria-label]="data.template.description || data.template.title || 'Campo de observação'"
            [formControl]="control"></textarea>

  <div class="dialog-actions actions d-flex justify-center mt-36"
       [ngClass]="{ 'dialog-actions--modern': appearance === 'modern' }"
       mat-dialog-actions>
    <button class="actions-btn btn-confirm"
            [ngClass]="{ 'actions-btn--modern-confirm': appearance === 'modern', 'actions-btn--modern-danger': appearance === 'modern' && isDestructive }"
            (click)="close(true)">
      {{ data.template.confirm }}
    </button>
    <button *ngIf="dialogType === DialogTypeEnum.Optional ||
                   dialogType === DialogTypeEnum.OptionalWithField"
            class="actions-btn {{ data.template.dismissClass ?? 'btn-dismiss' }} ml-16"
            [ngClass]="{ 'actions-btn--modern-dismiss': appearance === 'modern' }"
            (click)="close(false)">
      {{ data.template.dismiss }}
    </button>
  </div>
</div>
